import { Moment } from 'moment';
import { SystemUser } from './system-user';

export class StudentComment {

    constructor(
        public body: string,
        public created?: Moment,
        public createdBy?: SystemUser,
        public lastModified?: Moment,
        public lastModifiedBy?: SystemUser
    ){}
}
